import React, { useEffect } from 'react';
import { SiTicktick } from "react-icons/si";
import { FaFileAlt } from "react-icons/fa";
import AOS from 'aos';
import 'aos/dist/aos.css';

const IndividualTax = (props) => {

    const { title, desc1, desc2, desc3, img, IndividualCard, partnerLogo } = props;

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <>
         {partnerLogo && (
                <section className="container pt-4 mt-2" data-aos="fade-down">
                    <div
                        className="p-4 rounded-4 shadow-sm border d-flex flex-column flex-md-row align-items-center justify-content-between gap-4"
                        style={{
                            background: "#ffffff",
                            borderColor: "#e2e8f0",
                            borderRadius: "16px",
                        }}
                    >
                        <div className="d-flex flex-column flex-sm-row align-items-center gap-3 text-center text-sm-start">
                            <div
                                className="p-3 border rounded-3 d-flex align-items-center justify-content-center bg-white shadow-xs"
                                style={{ minWidth: "260px", height: "95px" }}
                            >
                                <img
                                    src={partnerLogo}
                                    alt="Magizhini Technology Services"
                                    style={{ maxHeight: "80px", maxWidth: "100%", objectFit: "contain" }}
                                />
                            </div>
                            <div>
                                <span
                                    className="badge mb-1 px-2 py-1"
                                    style={{ background: "#eff6ff", color: "#1d4ed8", fontSize: "0.75rem", letterSpacing: "0.05em", textTransform: "uppercase" }}
                                >
                                    Official Technology Partner
                                </span>
                                <h4 className="m-0 fw-bold text-dark fs-5">Magizhini Technology Services Canada</h4>
                                <p className="m-0 text-muted small">
                                    Custom Software Engineering, Web &amp; Mobile Apps, Cloud Infrastructure &amp; Digital Transformation.
                                </p>
                            </div>
                        </div>

                        <a
                            href="https://magizhinitech.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-primary fw-bold px-4 py-2 text-nowrap rounded-pill shadow-sm"
                            style={{ backgroundColor: "#2E6FF2", border: "none" }}
                        >
                            Visit magizhinitech.com &rarr;
                        </a>
                    </div>
                </section>
            )}
            <section className="svcdetail-intro">
                <div className="svcdetail-media" data-aos="fade-right">
                    <div className="svcdetail-media-frame">
                        <img src={img} alt={title} />
                    </div>
                    <div className="svcdetail-stamp">
                        <span className="svcdetail-stamp-icon"><FaFileAlt /></span>
                        <div className="svcdetail-stamp-text">
                            <span>Case File</span>
                            <strong>{title}</strong>
                        </div>
                    </div>
                </div>

                <div className="svcdetail-text" data-aos="fade-left">
                    <p className="svcdetail-eyebrow">Service Overview</p>
                    <h1>{title}</h1>
                    <p className="svcdetail-desc">{desc1}</p>
                    {desc2 && <p className="svcdetail-quote">{desc2}</p>}
                    {desc3 && <p className="svcdetail-desc">{desc3}</p>}
                </div>
            </section>

            <section className="svcdetail-features">
                <p className="svcdetail-eyebrow svcdetail-eyebrow-center">What's Included</p>
                <h2 className="svcdetail-features-title">Service Breakdown</h2>

                <div className="svcdetail-ledger">
                    {IndividualCard.map((card, i) => (
                        <div
                            className="svcdetail-ledger-row"
                            key={card.id}
                            data-aos="fade-up"
                            data-aos-delay={i * 60}
                        >
                            <span className="svcdetail-ledger-num">{String(i + 1).padStart(2, '0')}</span>
                            <span className="svcdetail-ledger-icon"><SiTicktick /></span>
                            <div className="svcdetail-ledger-copy">
                                <h4>{card.title}</h4>
                                <p>{card.para}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </>
    )
}

export default IndividualTax;